import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuftragsKomponente } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { BildVO } from '../auftragdetails.model';
import { KomponenteBase } from './komponente';

@Component({
    selector: 'auftrag-bilder2-komponente',
    template: `
        <div *ngIf="auftragdetails.bilder && auftragdetails.bilder.length">
          <div class="section">
            <div class="fotos-container">
              <div class="bild-container" *ngFor="let p of auftragdetails.bilder">
                <p *ngIf="p.bezeichnung">{{ p.bezeichnung }}</p>
                <img class="bild" [src]="domSanitizationService.bypassSecurityTrustUrl(p.src)" appClick (clicked)="onBildClicked(p)" [sensitivityX]="20" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="auftragdetails.anzeigeBild" class="anzeigebild">
            <pinch-zoom>
                <img class="bild" [src]="domSanitizationService.bypassSecurityTrustUrl(auftragdetails.anzeigeBild.src)" />
            </pinch-zoom>

            <ion-button expand="full" fill="clear" appClick (clicked)="onBildClicked(null)">
                <ion-ripple-effect></ion-ripple-effect>
                <ion-icon name="close"></ion-icon> Schließen
            </ion-button>
        </div>
    `,
    styles: [`    
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragBilder2Component extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    constructor(
        private router: Router,
        public domSanitizationService: DomSanitizer,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onBildClicked(vo: BildVO) {
        this.auftragdetails.anzeigeBild = vo;
    }
}
